const ValuationTypeEnum = Object.freeze({
    FUND: 'FUND',
    GROWTHINVEST: 'GROWTHINVEST',
    INSOLVENT: 'INSOLVENT',
    STOCK_EXCHANGE: 'STOCK_EXCHANGE'
});

export default ValuationTypeEnum;
